import React from 'react';
import { observer } from 'mobx-react-lite';

const TruckName = observer(({ type, truckName, truckModel }) => {
  if (!truckName) return null;

  // Maybe rewrite
  return (
    <tr>
      <td className="pale">{type && type === 'Полуприцеп' ? 'Полу-прицеп' : type}</td>
      <td>
        <span className="bold">
          {truckName} {truckModel}
        </span>
      </td>
    </tr>
  );
});

export default TruckName;
